import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';

interface PromptResponse {
    prompt?: string;
    redirectTo?: string;
}

interface RedirectToResponse {
    redirectTo: string;
}

const makeInteractionService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        setDebug: async (enabled: boolean) => {
            const res = await fetcher.get(`/debug/${enabled}`);
            return res;
        },

        getPrompt: async (uid: string): Promise<PromptResponse> => {
            const res = await fetcher.get(`/prompt/${uid}`);
            const jsonRes = (await res.json()) as PromptResponse;
            return jsonRes;
        },

        checkLogin: async (uid: string): Promise<RedirectToResponse> => {
            const res = await fetcher.post(`/${uid}`);
            const jsonRes = (await res.json()) as RedirectToResponse;
            return jsonRes;
        },
    };
};

export const interactionService = makeInteractionService(config.api.url.interaction);
